module.exports = __webpack_public_path__ + "static/pivonuv-beh-2021-02-07f2eceeaba5ce5643811eb72d5314b8.jpg";